import { createAsyncThunk } from "@reduxjs/toolkit";
import { getErrorPayload } from "@application/helpers/api-helper";
import PersonalInfoApi from "@infrastructure/personal-info-api";
export const PersonalInfoRegistertionAsync = createAsyncThunk("person/registration", async (personalInfo, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await PersonalInfoApi.Registeration(personalInfo);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const DirectorOrExternalPersonalInfoRegistertionAsync = createAsyncThunk("person/director-external-registration", async (personalInfo, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await PersonalInfoApi.DirectorOrExternalRegisteration(personalInfo);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const GetPersonalInfoByUserIdAsync = createAsyncThunk("person/getByUserId", async (request, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await PersonalInfoApi.GetPersonalInfoByUserId(request);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
